'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var SelectContainer = styled__default.span(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  box-shadow: 0px 2px 10px ", "1A;\n  border: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 12px 0;\n  border-radius: 12px;\n  padding: 15px;\n\n  &:hover {\n    box-shadow: 2px 0px 10px ", "1A;\n    cursor: pointer;\n  }\n"], ["\n  color: ", ";\n  box-shadow: 0px 2px 10px ", "1A;\n  border: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 12px 0;\n  border-radius: 12px;\n  padding: 15px;\n\n  &:hover {\n    box-shadow: 2px 0px 10px ", "1A;\n    cursor: pointer;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.$white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
}, function (_a) {
    var theme = _a.theme, isSelected = _a.isSelected;
    return "" + (isSelected ? "2px solid " + theme.colors.$primary : 0);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
});
var PriceContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-right: 25px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-right: 25px;\n"])));
var TextContainer = PriceContainer;
var Text = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 500 16px/19px ", ";\n  color: ", ";\n  overflow-wrap: break-word;\n"], ["\n  font: 500 16px/19px ", ";\n  color: ", ";\n  overflow-wrap: break-word;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var Price = styled__default(Text)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var TitleText = Text;
var SubtitleText = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  font: italic 12px/14px ", ";\n  color: ", ";\n"], ["\n  font: italic 12px/14px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var DescriptionText = styled__default(Price)(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  font: ", ";\n  color: ", ";\n"], ["\n  font: ",
    ";\n  color: ", ";\n"])), function (_a) {
    var price = _a.price, theme = _a.theme;
    return "" + (price
        ? "italic 12px/14px " + theme.fonts.join()
        : "italic 14px/16px  " + theme.fonts.join());
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$sharedGreyDark;
});
var Description = styled__default(Price)(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  font: italic 14px/16px ", ";\n  color: ", ";\n"], ["\n  font: italic 14px/16px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$sharedGreyDark;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports.DescriptionText = DescriptionText;
exports.Price = Price;
exports.PriceContainer = PriceContainer;
exports.SelectContainer = SelectContainer;
exports.SubtitleText = SubtitleText;
exports.TextContainer = TextContainer;
exports.TitleText = TitleText;
